const text = 'text';
const dropdown = 'dropdown';
const image = 'image';

export default { text, dropdown, image };
